import React, { useState } from "react";
import { Button } from "../ButtonElement";
import {
  HeroContainer,
  HeroBg,
  HeroBtnWrapper,
  HeroContent,
  HeroH1,
  HeroP,
  ArrowForward,
  ArrowRight,
} from "./HeroElementsEN";

const HeroSectionEN = ({ id }) => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  return (
    <HeroContainer id={id}>
      <HeroBg></HeroBg>
      <HeroContent>
        <HeroH1>
          Welcome to the website of manufacturer of
          <br />
          peaks and adjusters for caps.
        </HeroH1>
        <HeroP>We invite you to familiarize yourself with our offer.</HeroP>
        <HeroBtnWrapper>
          <Button
            to="about"
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            primary="true"
            dark="true"
            smooth={true}
            duration={500}
            spy={true}
            exact={true}
            offset={-75}
          >
            Let's Begin{hover ? <ArrowForward /> : <ArrowRight />}{" "}
          </Button>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSectionEN;
